import { LocalParticipant, Participant } from 'livekit-client';
import { parseParticipantMetadata } from 'useCase';
import { raiseHandSound } from 'features/RaiseHand/classes/RaiseHandSound';

interface PlayRaiseHandSoundProps {
    prevMetadata: string | undefined;
    currMetadata: string | undefined;
}

interface UseRaiseHand {
    checkIsHandRaised: (participant: Participant) => boolean | undefined;
    checkIsHandRaisedInMetadata: (stringifiedMetadata?: string | undefined) => boolean | undefined;
    toggleRaiseHand: (participant: LocalParticipant) => void;
    playRaiseHandSound: (props: PlayRaiseHandSoundProps) => void;
}

export const useRaiseHand = (): UseRaiseHand => {
    const checkIsHandRaised = (participant: Participant) => {
        return checkIsHandRaisedInMetadata(participant.metadata);
    };

    const checkIsHandRaisedInMetadata = (stringifiedMetadata?: string) => {
        const metadata = parseParticipantMetadata(stringifiedMetadata);
        const { handRaised } = metadata as { handRaised?: boolean };
        return handRaised;
    };

    const toggleRaiseHand = (participant: LocalParticipant) => {
        const metadata = parseParticipantMetadata(participant.metadata);
        const handRaised = checkIsHandRaised(participant);
        const data = JSON.stringify({
            ...metadata,
            handRaised: !handRaised,
        });
        participant.setMetadata(data);
    };

    const playRaiseHandSound = ({ prevMetadata, currMetadata }: PlayRaiseHandSoundProps) => {
        const wasHandRaised = checkIsHandRaisedInMetadata(prevMetadata);
        const isHandRaised = checkIsHandRaisedInMetadata(currMetadata);

        if (isHandRaised && !wasHandRaised) {
            raiseHandSound.playSound();
        }
    };

    return {
        checkIsHandRaised,
        checkIsHandRaisedInMetadata,
        toggleRaiseHand,
        playRaiseHandSound,
    };
};
